"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumFrequency = void 0;
exports.EnumFrequency = {
    AsNeeded: 'AsNeeded',
    EveryDay: 'EveryDay',
    DaysInterval: 'DaysInterval',
    SpecificDays: 'SpecificDays',
};
//# sourceMappingURL=enum-frequency.js.map